import React from 'react'
import MultiSelect from 'components/MultiSelect'
import { FormattedMessage } from 'react-intl'
import Button from 'components/Button'
import DropdownButton from 'components/DropdownButton'
import {
  showAllProfiles,
  hideAllProfiles,
  showProfile,
  hideProfile
} from './actions'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  selectProfileOptions,
  selectVisibleProfiles,
  selectProfiles
} from './selectors'

const mapStateToSelectProps = state => {
  return {
    options: selectProfileOptions(state),
    columnsCount: 2,
    singleColumnWidth: 1120
  }
}

const mapDispatchToSelectProps = {
  onSelect: showProfile,
  onDeselect: hideProfile
}

const Select = connect(
  mapStateToSelectProps,
  mapDispatchToSelectProps
)(MultiSelect)

const MonthlyEvaluationProfilesDropdown = ({
  showAllProfiles,
  hideAllProfiles,
  profilesCount
}) => {
  return (
    <div style={{ marginLeft: 10 }}>
      <DropdownButton
        color='default'
        className='btn--flex'
        popperConfig={{ placement: 'bottom-end' }}
        content={() => (
          <div className='multi-select-box multi-select-box multi-select-box--realization-menu'>
            <div className='multi-select-box__actions'>
              <Button size='small' color='secondary' onClick={showAllProfiles}>
                <FormattedMessage id='selectAll' />
              </Button>
              <Button size='small' color='secondary' onClick={hideAllProfiles}>
                <FormattedMessage id='selectNone' />
              </Button>
            </div>

            <div className='multi-select-box__select'>
              <Select />
            </div>
          </div>
        )}
      >
        {profilesCount < 0 && (
          <FormattedMessage id='reports.monthlyEvaluation.allProfiles' />
        )}
        {profilesCount === 0 && (
          <FormattedMessage id='reports.monthlyEvaluation.noneProfile' />
        )}
        {profilesCount > 0 && (
          <FormattedMessage
            id='reports.monthlyEvaluation.nProfiles'
            values={{ n: profilesCount }}
          />
        )}
      </DropdownButton>
    </div>
  )
}

MonthlyEvaluationProfilesDropdown.propTypes = {
  showAllProfiles: PropTypes.func,
  hideAllProfiles: PropTypes.func,
  profilesCount: PropTypes.number
}

const mapStateToProps = state => {
  const visibleProfilesCount = selectVisibleProfiles(state).length
  const profilesCount = selectProfiles(state).length

  return {
    profilesCount:
      profilesCount === visibleProfilesCount ? -1 : visibleProfilesCount
  }
}

const mapDispatchToProps = {
  showAllProfiles,
  hideAllProfiles
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MonthlyEvaluationProfilesDropdown)
